import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { inspectionsEnabledGuard } from './core/guards/module-enabled.guard';
import { LayoutAppComponent } from './core/layouts/layout-app/layout-app.component';
import { LayoutEmptyComponent } from './core/layouts/layout-empty/layout-empty.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';

export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

  // empty layout routes
  {
    path: '',
    component: LayoutEmptyComponent,
    children: [{ path: '', loadChildren: () => import('app/modules/auth/auth.routes'), canActivate: [guestGuard] }],
  },

  // app layout routes
  {
    path: '',
    component: LayoutAppComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, title: 'ISKAAN' },
      { path: 'profile', loadChildren: () => import('app/modules/profile/profile.routes') },
      { path: 'standards', loadChildren: () => import('app/modules/standards/standards.routes') },
      { path: 'associations', loadChildren: () => import('app/modules/associations/associations.routes') },
      { path: 'procurement', loadChildren: () => import('app/modules/procurement/procurement.routes') },
      { path: 'inspections', loadChildren: () => import('app/modules/inspections/inspections.routes'), canActivate: [inspectionsEnabledGuard] },
      { path: 'directories', loadChildren: () => import('app/modules/directories/directories.routes') },
      { path: 'admin', loadChildren: () => import('app/modules/admin/admin.routes') },
      { path: 'recovery', loadChildren: () => import('app/modules/recovery/recovery.routes') },
      { path: 'communication', loadChildren: () => import('app/modules/communication/communication.routes') },
      { path: 'violations', loadChildren: () => import('app/modules/violations/violations.routes') },
      { path: 'compliances', loadChildren: () => import('app/modules/compliances/compliances.routes') },
      { path: 'activities', loadChildren: () => import('app/modules/activities/activities.routes') },
      { path: 'tasks', loadChildren: () => import('app/modules/tasks/tasks.routes') },
      { path: 'accounting', loadChildren: () => import('app/modules/accounting/accounting.routes') },
      // { path: 'company-books', loadChildren: () => import('app/modules/company-books/company-books.routes') },
      { path: 'notifications', loadChildren: () => import('app/modules/notifications/notifications.routes') },
      { path: 'happiness-center', loadChildren: () => import('app/modules/happiness-center/happiness-center.routes') },
      { path: 'insurances', loadChildren: () => import('app/modules/insurance/insurance.routes') },
      { path: 'eservices', loadChildren: () => import('app/modules/eservices/eservices.routes') },
      { path: 'reports', loadChildren: () => import('app/modules/reports/reports.routes') },
      { path: 'utility', loadChildren: () => import('app/modules/directories/utility.routes') },
      {
        path: ':ref_type/:ref_id/bank-account',
        loadComponent: () => import('app/modules/bank-accounts/bank-account-page/bank-account-page.component').then((m) => m.BankAccountPageComponent),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('app/modules/not-found/not-found.component').then((m) => m.NotFoundComponent),
    title: 'ISKAAN - Page Not Found',
  },
];
